import { getCameraKitUserAgent } from "../platform/cameraKitUserAgent";
import { ExtensionRequestContext } from "../generated-proto/pb_schema/camera_kit/v3/export";
import { getPlatformInfo } from "../platform/platformInfo";
import { memoize } from "../common/memoize";

/**
 * Returns extension request context.
 */
export const getExtensionRequestContext = memoize(function getExtensionRequestContext(): ArrayBuffer {
    return ExtensionRequestContext.encode({
        userAgent: getCameraKitUserAgent(),
        locale: getPlatformInfo().fullLocale,
    }).finish();
});

/**
 * Extension request context.
 *
 * @deprecated Use {@link getExtensionRequestContext}
 */
export const extensionRequestContext = getExtensionRequestContext();
